import React, { useState, useEffect } from 'react';
import { Card, CardContent } from "./components/ui/card";
import { Button } from "./components/ui/button";
import { Mail, Phone, MapPin, Scale, Users, FileText, ChevronLeft, ChevronRight } from "lucide-react";
import { motion } from "framer-motion";

export default function AdvocateWebsite() {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [activeSection, setActiveSection] = useState('home');
  const [showModal, setShowModal] = useState(false);
  const [showFixedNav, setShowFixedNav] = useState(false);
  const [touchStart, setTouchStart] = useState(0);
  const [touchEnd, setTouchEnd] = useState(0);
  const [isPaused, setIsPaused] = useState(false);
  const [showDisclaimer, setShowDisclaimer] = useState(true);
  const [expandedCard, setExpandedCard] = useState(null);
  const [expandedService, setExpandedService] = useState(null);
  const [practiceAreaModal, setPracticeAreaModal] = useState(null);
  const [qualificationModal, setQualificationModal] = useState(null);
  const [serviceModal, setServiceModal] = useState(null);
  const [showFAQ, setShowFAQ] = useState(false);
  const [expandedFAQ, setExpandedFAQ] = useState(null);
  const [showAreasOfLaw, setShowAreasOfLaw] = useState(false);
  const [selectedLegalArea, setSelectedLegalArea] = useState(null);

  const handleDisclaimerAccept = () => {
    setShowDisclaimer(false);
  };

  const handleTouchStart = (e) => {
    setTouchStart(e.targetTouches[0].clientX);
    setIsPaused(true);
  };

  const handleTouchMove = (e) => {
    setTouchEnd(e.targetTouches[0].clientX);
  };

  const handleTouchEnd = () => {
    if (!touchStart || !touchEnd) {
      setTimeout(() => setIsPaused(false), 2000);
      return;
    }
    const distance = touchStart - touchEnd;
    const isLeftSwipe = distance > 50;
    const isRightSwipe = distance < -50;
    
    if (isLeftSwipe) {
      setCurrentSlide((prev) => (prev + 1) % carouselItems.length);
    }
    if (isRightSwipe) {
      setCurrentSlide((prev) => (prev - 1 + carouselItems.length) % carouselItems.length);
    }
    setTimeout(() => setIsPaused(false), 2000);
  };
  const [formData, setFormData] = useState({
    name: '',
    phone: '',
    email: '',
    service: '',
    query: '',
    countryCode: '+91'
  });

  const countryCodes = [
    { code: '+91', country: 'India' },
    { code: '+1', country: 'USA/Canada' },
    { code: '+44', country: 'UK' },
    { code: '+971', country: 'UAE' },
    { code: '+65', country: 'Singapore' },
    { code: '+61', country: 'Australia' },
    { code: '+49', country: 'Germany' },
    { code: '+33', country: 'France' },
    { code: '+39', country: 'Italy' },
    { code: '+34', country: 'Spain' },
    { code: '+31', country: 'Netherlands' },
    { code: '+41', country: 'Switzerland' },
    { code: '+43', country: 'Austria' },
    { code: '+32', country: 'Belgium' },
    { code: '+45', country: 'Denmark' },
    { code: '+46', country: 'Sweden' },
    { code: '+47', country: 'Norway' },
    { code: '+358', country: 'Finland' },
    { code: '+353', country: 'Ireland' },
    { code: '+351', country: 'Portugal' },
    { code: '+30', country: 'Greece' },
    { code: '+48', country: 'Poland' },
    { code: '+420', country: 'Czech Republic' },
    { code: '+36', country: 'Hungary' },
    { code: '+7', country: 'Russia' },
    { code: '+86', country: 'China' },
    { code: '+81', country: 'Japan' },
    { code: '+82', country: 'South Korea' },
    { code: '+852', country: 'Hong Kong' },
    { code: '+853', country: 'Macau' },
    { code: '+886', country: 'Taiwan' },
    { code: '+60', country: 'Malaysia' },
    { code: '+66', country: 'Thailand' },
    { code: '+62', country: 'Indonesia' },
    { code: '+63', country: 'Philippines' },
    { code: '+84', country: 'Vietnam' },
    { code: '+855', country: 'Cambodia' },
    { code: '+856', country: 'Laos' },
    { code: '+95', country: 'Myanmar' },
    { code: '+880', country: 'Bangladesh' },
    { code: '+94', country: 'Sri Lanka' },
    { code: '+977', country: 'Nepal' },
    { code: '+975', country: 'Bhutan' },
    { code: '+960', country: 'Maldives' },
    { code: '+92', country: 'Pakistan' },
    { code: '+93', country: 'Afghanistan' },
    { code: '+98', country: 'Iran' },
    { code: '+964', country: 'Iraq' },
    { code: '+962', country: 'Jordan' },
    { code: '+961', country: 'Lebanon' },
    { code: '+972', country: 'Israel' },
    { code: '+966', country: 'Saudi Arabia' },
    { code: '+968', country: 'Oman' },
    { code: '+973', country: 'Bahrain' },
    { code: '+974', country: 'Qatar' },
    { code: '+965', country: 'Kuwait' },
    { code: '+967', country: 'Yemen' },
    { code: '+90', country: 'Turkey' },
    { code: '+20', country: 'Egypt' },
    { code: '+27', country: 'South Africa' },
    { code: '+234', country: 'Nigeria' },
    { code: '+254', country: 'Kenya' },
    { code: '+233', country: 'Ghana' },
    { code: '+212', country: 'Morocco' },
    { code: '+213', country: 'Algeria' },
    { code: '+216', country: 'Tunisia' },
    { code: '+55', country: 'Brazil' },
    { code: '+54', country: 'Argentina' },
    { code: '+56', country: 'Chile' },
    { code: '+57', country: 'Colombia' },
    { code: '+51', country: 'Peru' },
    { code: '+58', country: 'Venezuela' },
    { code: '+52', country: 'Mexico' },
    { code: '+506', country: 'Costa Rica' },
    { code: '+507', country: 'Panama' },
    { code: '+64', country: 'New Zealand' },
    { code: '+679', country: 'Fiji' }
  ];

  const handlePhoneChange = (e) => {
    const value = e.target.value.replace(/\D/g, '');
    if (value.length <= 10) {
      setFormData({...formData, phone: value});
    }
  };

  const handleWhatsApp = () => {
    const message = "Hello, I would like to schedule a legal consultation with Advocate Meyhul Miittal.";
    const whatsappUrl = `https://wa.me/919928228793?text=${encodeURIComponent(message)}`;
    window.open(whatsappUrl, '_blank');
  };

  const handleDownloadBrochure = () => {
    // Create a simple brochure content
    const brochureContent = `
MEYHUL MIITTAL - ADVOCATE & CONSULTANT

Qualifications: B.B.A. | LL.B. | LL.M.

PRACTICE AREAS:
• Litigation & Representation
• Legal Drafting & Documentation  
• Corporate Legal Advisory
• Real Estate & RERA Compliance
• Dispute Resolution & Negotiation
• Audit & Tax Advisory

FORUMS:
• High Court of Rajasthan
• NCLT, DRT, RERA
• Consumer Forums
• District & Sessions Courts

CONTACT:
Phone: +91 9928228793
Email: meyhul@outlook.com

Disclaimer: This is for informational purposes only in compliance with BCI Rules.
    `;
    
    const blob = new Blob([brochureContent], { type: 'text/plain' });
    const url = window.URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = 'Meyhul-Miittal-Legal-Practice-Overview.txt';
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    window.URL.revokeObjectURL(url);
  };

  const handleConsultation = () => {
    setShowModal(true);
  };

  const handleFormSubmit = (e) => {
    e.preventDefault();
    const emailBody = `Name: ${formData.name}\nPhone: ${formData.countryCode} ${formData.phone}\nEmail: ${formData.email}\nQuery: ${formData.query}`;
    const mailtoUrl = `mailto:meyhul@outlook.com?subject=Legal Consultation Request&body=${encodeURIComponent(emailBody)}`;
    window.open(mailtoUrl, '_blank');
    setShowModal(false);
    setFormData({ name: '', phone: '', email: '', service: '', query: '', countryCode: '+91' });
  };

  const carouselItems = [
    {
      title: "Criminal Law",
      description: "Professional legal representation in criminal matters",
      icon: <Scale className="w-12 h-12 text-yellow-400" />,
      details: "Expert legal counsel in criminal proceedings including bail applications, trial advocacy, and appellate matters. Specialized in white-collar offenses, economic disputes, and regulatory compliance issues."
    },
    {
      title: "Civil Litigation",
      description: "Professional representation in civil disputes and contracts",
      icon: <FileText className="w-12 h-12 text-yellow-400" />,
      details: "Expert handling of property disputes, contract breaches, tort claims, and commercial litigation. Strategic approach to achieve favorable settlements and court victories."
    },
    {
      title: "Corporate Law",
      description: "Business legal solutions and compliance advisory",
      icon: <Users className="w-12 h-12 text-yellow-400" />,
      details: "Complete corporate legal services including company formation, compliance, mergers & acquisitions, employment law, and regulatory advisory for businesses of all sizes."
    }
  ];

  useEffect(() => {
    if (isPaused) return;
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % carouselItems.length);
    }, 4000);
    return () => clearInterval(timer);
  }, [carouselItems.length, isPaused]);

  const scrollToSection = (sectionId) => {
    setActiveSection(sectionId);
    if (sectionId === 'home') {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    } else {
      document.getElementById(sectionId)?.scrollIntoView({ behavior: 'smooth' });
    }
  };

  // Track scroll position to update active section and show/hide fixed nav
  useEffect(() => {
    const handleScroll = () => {
      const sections = ['why-choose-me', 'services', 'professional-experience', 'about-me', 'about', 'contact'];
      const scrollPosition = window.scrollY + 100;
      const heroHeight = 400; // Approximate hero section height
      
      // Show fixed nav when scrolled past hero section
      setShowFixedNav(scrollPosition > heroHeight);
      
      if (scrollPosition < 300) {
        setActiveSection('home');
        return;
      }
      
      for (const section of sections) {
        const element = document.getElementById(section);
        if (element) {
          const { offsetTop, offsetHeight } = element;
          if (scrollPosition >= offsetTop && scrollPosition < offsetTop + offsetHeight) {
            setActiveSection(section);
            break;
          }
        }
      }
    };
    
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div className="bg-white text-gray-900 font-sans min-w-0 overflow-x-hidden">
      {/* Disclaimer Popup */}
      {showDisclaimer && (
        <div className="fixed inset-0 bg-black bg-opacity-60 flex items-center justify-center z-50 p-4 overflow-x-hidden">
          <div className="bg-white rounded-lg p-6 md:p-8 w-full max-w-md mx-4 text-center shadow-2xl max-h-[90vh] overflow-y-auto">
            <h2 className="text-xl md:text-2xl font-bold mb-4 md:mb-6 text-blue-900">Welcome to the Official Website of Meyhul Miittal</h2>
            <p className="text-gray-700 leading-relaxed text-justify mb-4 md:mb-6 text-sm md:text-base">
              As per the rules of the Bar Council of India, I am not permitted to solicit work or advertise. 
              By proceeding, you acknowledge that you are seeking information voluntarily and that there has been 
              no solicitation, invitation, or inducement by the advocate or the website.
            </p>
            <Button 
              onClick={handleDisclaimerAccept}
              className="bg-blue-600 hover:bg-blue-700 text-white px-6 md:px-8 py-3 text-sm md:text-base"
            >
              I Agree & Proceed
            </Button>
          </div>
        </div>
      )}
      {/* Fixed Navigation - only shows when scrolled past hero */}
      {showFixedNav && (
        <nav className="fixed top-0 left-0 right-0 bg-slate-900/95 backdrop-blur-md shadow-2xl z-40 py-4 overflow-x-hidden">
          <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-sm md:text-base font-light tracking-wide px-4">
            <button onClick={() => scrollToSection('home')} className={`px-3 py-2 transition-all duration-300 border-b-2 whitespace-nowrap rounded hover:bg-white/10 ${activeSection === 'home' ? 'text-yellow-400 border-yellow-400' : 'text-white border-transparent hover:text-yellow-400 hover:border-yellow-400'}`}>Home</button>
            <button onClick={() => scrollToSection('why-choose-me')} className={`px-3 py-2 transition-all duration-300 border-b-2 whitespace-nowrap rounded hover:bg-white/10 ${activeSection === 'why-choose-me' ? 'text-yellow-400 border-yellow-400' : 'text-white border-transparent hover:text-yellow-400 hover:border-yellow-400'}`}>Why Choose Me</button>
            <button onClick={() => scrollToSection('services')} className={`px-3 py-2 transition-all duration-300 border-b-2 whitespace-nowrap rounded hover:bg-white/10 ${activeSection === 'services' ? 'text-yellow-400 border-yellow-400' : 'text-white border-transparent hover:text-yellow-400 hover:border-yellow-400'}`}>Services</button>
            <button onClick={() => scrollToSection('professional-experience')} className={`px-3 py-2 transition-all duration-300 border-b-2 whitespace-nowrap rounded hover:bg-white/10 ${activeSection === 'professional-experience' ? 'text-yellow-400 border-yellow-400' : 'text-white border-transparent hover:text-yellow-400 hover:border-yellow-400'}`}>Experience</button>
            <button onClick={() => scrollToSection('about-me')} className={`px-3 py-2 transition-all duration-300 border-b-2 whitespace-nowrap rounded hover:bg-white/10 ${activeSection === 'about-me' ? 'text-yellow-400 border-yellow-400' : 'text-white border-transparent hover:text-yellow-400 hover:border-yellow-400'}`}>About Me</button>
            <button onClick={() => scrollToSection('contact')} className={`px-3 py-2 transition-all duration-300 border-b-2 whitespace-nowrap rounded hover:bg-white/10 ${activeSection === 'contact' ? 'text-yellow-400 border-yellow-400' : 'text-white border-transparent hover:text-yellow-400 hover:border-yellow-400'}`}>Contact</button>
          </div>
        </nav>
      )}

      {/* Hero Section */}
      <section className="relative bg-gradient-to-r from-slate-800 via-slate-900 to-black text-white py-12 px-6 shadow-2xl">
        <div className="absolute inset-0 bg-black/20"></div>
        <div className="relative z-10 max-w-6xl mx-auto">
          <div className="grid lg:grid-cols-2 gap-12 items-center">
            {/* Left side - Profile image */}
            <div className="flex justify-center lg:justify-start">
              <motion.div 
                initial={{ opacity: 0, scale: 0.8 }} 
                animate={{ opacity: 1, scale: 1 }} 
                transition={{ duration: 1, delay: 0.3 }}
                className="relative"
              >
                <div className="w-80 h-80 rounded-full overflow-hidden border-4 border-yellow-400 shadow-2xl">
                  <img 
                    src="./profile.jpeg" 
                    alt="Advocate Meyhul Miittal" 
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="absolute -bottom-4 -right-4 w-16 h-16 bg-yellow-600 rounded-full flex items-center justify-center shadow-lg">
                  <Scale className="w-8 h-8 text-white" />
                </div>
              </motion.div>
            </div>
            
            {/* Right side - Text content */}
            <div className="text-center lg:text-left">
              <motion.h1 initial={{ opacity: 0, y: -20 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 1 }} className="text-6xl font-light mb-6 tracking-wide">
                Meyhul Miittal
              </motion.h1>
              <div className="w-full h-0.5 bg-yellow-400 mx-auto lg:mx-0 mb-6"></div>
              <p className="text-2xl mb-2 font-light tracking-wide">
                Advocate & Consultant
              </p>
              <p className="text-lg mb-8 text-gray-300 font-light">
                B.B.A. | LL.B. | LL.M.
              </p>
              <div className="flex justify-center lg:justify-start gap-6 mb-12">
                <Button onClick={handleConsultation} className="bg-yellow-600 text-white hover:bg-yellow-700 px-8 py-3 text-lg font-medium rounded-none border-0 shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-105">
                  Schedule Consultation
                </Button>
                <Button onClick={handleWhatsApp} variant="outline" className="border-2 border-white text-white hover:bg-white hover:text-slate-900 px-8 py-3 text-lg font-medium rounded-none transition-all duration-300 hover:scale-105">
                  WhatsApp
                </Button>
              </div>
            </div>
          </div>
          
          {/* Static Navigation - only visible in hero section */}
          <nav className="flex flex-wrap justify-center gap-4 md:gap-8 text-sm md:text-base font-light tracking-wide mt-8 px-4">
            <button onClick={() => scrollToSection('why-choose-me')} className={`hover:text-yellow-400 transition-all duration-300 pb-1 border-b-2 hover:scale-105 whitespace-nowrap px-3 py-2 rounded hover:bg-white/10 ${activeSection === 'why-choose-me' ? 'text-yellow-400 border-yellow-400' : 'border-transparent hover:border-yellow-400'}`}>Why Choose Me</button>
            <button onClick={() => scrollToSection('services')} className={`hover:text-yellow-400 transition-all duration-300 pb-1 border-b-2 hover:scale-105 whitespace-nowrap px-3 py-2 rounded hover:bg-white/10 ${activeSection === 'services' ? 'text-yellow-400 border-yellow-400' : 'border-transparent hover:border-yellow-400'}`}>Services</button>
            <button onClick={() => scrollToSection('professional-experience')} className={`hover:text-yellow-400 transition-all duration-300 pb-1 border-b-2 hover:scale-105 whitespace-nowrap px-3 py-2 rounded hover:bg-white/10 ${activeSection === 'professional-experience' ? 'text-yellow-400 border-yellow-400' : 'border-transparent hover:border-yellow-400'}`}>Experience</button>
            <button onClick={() => scrollToSection('about-me')} className={`hover:text-yellow-400 transition-all duration-300 pb-1 border-b-2 hover:scale-105 whitespace-nowrap px-3 py-2 rounded hover:bg-white/10 ${activeSection === 'about-me' ? 'text-yellow-400 border-yellow-400' : 'border-transparent hover:border-yellow-400'}`}>About Me</button>
            <button onClick={() => scrollToSection('contact')} className={`hover:text-yellow-400 transition-all duration-300 pb-1 border-b-2 hover:scale-105 whitespace-nowrap px-3 py-2 rounded hover:bg-white/10 ${activeSection === 'contact' ? 'text-yellow-400 border-yellow-400' : 'border-transparent hover:border-yellow-400'}`}>Contact</button>
            <button onClick={() => setShowFAQ(true)} className="hover:text-yellow-400 transition-all duration-300 pb-1 border-b-2 hover:scale-105 border-transparent hover:border-yellow-400 whitespace-nowrap px-3 py-2 rounded hover:bg-white/10">FAQ</button>
            <button onClick={() => setShowAreasOfLaw(true)} className="hover:text-yellow-400 transition-all duration-300 pb-1 border-b-2 hover:scale-105 border-transparent hover:border-yellow-400 whitespace-nowrap px-3 py-2 rounded hover:bg-white/10">Areas of Law</button>
          </nav>
        </div>
      </section>

      {/* Why Choose Me Section */}
      <section id="why-choose-me" className="relative py-20 px-6 bg-gradient-to-br from-slate-50 to-white overflow-hidden">
        <div className="absolute top-0 right-0 w-1/3 h-full bg-gradient-to-l from-yellow-600/10 to-transparent"></div>
        <div className="max-w-7xl mx-auto relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 20 }} 
            whileInView={{ opacity: 1, y: 0 }} 
            transition={{ duration: 0.8 }}
            className="text-center mb-16"
          >
            <h2 className="text-5xl font-light text-slate-800 mb-4 tracking-wide">
              Why Choose Me
            </h2>
            <div className="w-24 h-0.5 bg-yellow-400 mx-auto mb-6"></div>
            <p className="text-xl text-gray-600 font-light">Your Success is My Commitment</p>
          </motion.div>
          
          <div className="grid lg:grid-cols-12 gap-8 items-center mb-20">
            <div className="lg:col-span-7 lg:col-start-1">
              <div className="relative">
                <div className="absolute -right-8 -top-8 w-16 h-16 bg-yellow-600/20 rounded-full"></div>
                <p className="text-gray-700 leading-relaxed text-xl text-justify font-light mb-8 relative z-10">
                  Selecting legal representation is a decision that significantly impacts the outcome of your legal or business matter. 
                  I bring a distinct advantage through my integrated expertise in law, finance, and business operations—allowing me to 
                  provide solutions that are not only legally sound but also strategically informed and commercially viable.
                </p>
                <div className="flex gap-4">
                  <Button onClick={handleConsultation} className="bg-yellow-600 text-white hover:bg-yellow-700 px-6 py-3 rounded-full shadow-lg transform hover:scale-105 transition-all">
                    Get Started
                  </Button>
                  <Button onClick={handleWhatsApp} variant="outline" className="border-2 border-slate-800 text-slate-800 hover:bg-slate-800 hover:text-white px-6 py-3 rounded-full transform hover:scale-105 transition-all">
                    Quick Chat
                  </Button>
                </div>
              </div>
            </div>
            <div className="lg:col-span-4 lg:col-start-9 relative">
              <div className="relative">
                <div className="w-full h-80 bg-gradient-to-br from-slate-100 to-slate-200 rounded-2xl overflow-hidden shadow-2xl">
                  <img 
                    src="./WhyChooseMe.jpg" 
                    alt="Why Choose Meyhul Miittal" 
                    className="w-full h-full object-cover"
                  />
                </div>
                <div className="absolute -bottom-6 -right-6 w-24 h-24 bg-yellow-600 rounded-full flex items-center justify-center shadow-lg">
                  <Users className="w-12 h-12 text-white" />
                </div>
                <div className="absolute -top-4 -left-4 w-16 h-16 bg-slate-800 rounded-full flex items-center justify-center">
                  <FileText className="w-8 h-8 text-white" />
                </div>
              </div>
            </div>
          </div>
          
          {/* My Core Values Section */}
          <motion.div
            initial={{ opacity: 0, y: 20 }} 
            whileInView={{ opacity: 1, y: 0 }} 
            transition={{ duration: 0.8 }}
            className="text-center mb-8"
          >
            <h3 className="text-4xl font-light text-slate-800 mb-4 tracking-wide">
              My Core Values
            </h3>
            <div className="w-16 h-0.5 bg-yellow-600 mx-auto mb-6"></div>
            <p className="text-lg text-gray-600 font-light mb-8">The principles that guide my practice</p>
            <div className="max-w-4xl mx-auto">
              <p className="text-gray-700 leading-relaxed text-xl text-justify font-light mb-4">
                My approach is rooted in thorough legal research, client-centric strategy, and proactive communication. 
                I do not believe in one-size-fits-all legal services. Every client's matter is unique, and I dedicate the time 
                and attention necessary to understand its nuances and provide tailored solutions that align with your goals.
              </p>
            </div>
          </motion.div>
          
          {(() => {
            const cards = [
              {
                id: 'expertise',
                icon: <Scale className="w-6 h-6 text-slate-700" />,
                bgColor: 'bg-slate-100',
                borderColor: 'border-slate-600',
                title: 'Integrated Expertise',
                description: 'Unique combination of law, finance, and business operations expertise delivering legally sound and commercially viable solutions.',
                details: 'My multidisciplinary background allows me to understand not just the legal implications but also the business and financial impact of every decision, ensuring holistic solutions.'
              },
              {
                id: 'client-centric',
                icon: <Users className="w-6 h-6 text-slate-700" />,
                bgColor: 'bg-slate-100',
                borderColor: 'border-slate-600',
                title: 'Client-Centric Approach',
                description: 'Every client is unique, and so is my approach. Personalized legal solutions with clear communication throughout.',
                details: 'Every client is unique, and so is my approach. I prioritize understanding your specific needs and objectives, offering personalized legal solutions and clear communication throughout. My focus is on building long-term relationships grounded in reliability, responsiveness, and results.'
              },
              {
                id: 'forum-experience',
                icon: <FileText className="w-6 h-6 text-slate-700" />,
                bgColor: 'bg-slate-100',
                borderColor: 'border-slate-600',
                title: 'Diverse Forum Experience',
                description: 'Extensive experience across High Court, RERA, NCLT, and other judicial forums providing versatility to navigate complex frameworks.',
                details: 'My practice spans multiple jurisdictions and specialized tribunals, giving me the expertise to handle diverse legal matters with confidence and strategic insight.'
              },
              {
                id: 'trust-transparency',
                icon: <Mail className="w-6 h-6 text-slate-700" />,
                bgColor: 'bg-slate-100',
                borderColor: 'border-slate-600',
                title: 'Integrity & Confidentiality',
                description: 'Upholding the highest standards of professional ethics with absolute integrity and discretion in all client matters.',
                details: 'I uphold the highest standards of professional ethics, ensuring that all client matters are handled with absolute integrity and discretion. Trust is the cornerstone of my practice, and every engagement is treated with the utmost confidentiality and responsibility.'
              },
              {
                id: 'strategic-problem-solving',
                icon: <FileText className="w-6 h-6 text-slate-700" />,
                bgColor: 'bg-slate-100',
                borderColor: 'border-slate-600',
                title: 'Strategic Problem-Solving',
                description: 'Approaching each legal challenge with precision, insight, and strategic foresight for practical and effective outcomes.',
                details: 'I approach each legal challenge with precision, insight, and strategic foresight. My solutions are rooted in thorough analysis and tailored to meet both legal and commercial objectives, ensuring outcomes that are practical, effective, and sustainable.'
              }
            ];

            if (!expandedCard) {
              // Show all 5 cards side by side when none is expanded
              return (
                <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-4 mb-12">
                  {cards.map((card, index) => (
                    <motion.div
                      key={card.id}
                      initial={{ opacity: 0, y: 20 }}
                      whileInView={{ opacity: 1, y: 0 }}
                      transition={{ duration: 0.8, delay: index * 0.1 }}
                      className="h-full"
                    >
                      <div 
                        className={`border-l-4 ${card.borderColor} bg-white shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer h-full flex flex-col rounded-lg hover:scale-105`}
                        onClick={() => setExpandedCard(card.id)}
                      >
                        <div className="p-6 flex-1 flex flex-col">
                          <div className="flex items-center mb-4">
                            <div className={`w-12 h-12 ${card.bgColor} rounded-full flex items-center justify-center mr-4 flex-shrink-0`}>
                              {card.icon}
                            </div>
                            <h3 className="text-lg font-semibold text-blue-800 leading-tight">{card.title}</h3>
                          </div>
                          <div className="text-center mt-auto pt-4">
                            <span className="text-xs text-gray-400">Click to expand</span>
                          </div>
                        </div>
                      </div>
                    </motion.div>
                  ))}
                </div>
              );
            } else {
              // Show expanded layout: left column with all cards, right column with expanded card details
              const expandedCardData = cards.find(card => card.id === expandedCard);
              
              return (
                <div className="grid lg:grid-cols-3 gap-8 mb-12">
                  {/* Left column - All cards stacked with expanded one highlighted */}
                  <div className="lg:col-span-1 space-y-4 h-fit">
                    {cards.map((card) => (
                      <motion.div
                        key={card.id}
                        initial={{ opacity: 0, x: -20 }}
                        animate={{ opacity: 1, x: 0 }}
                        transition={{ duration: 0.3 }}
                      >
                        <div 
                          className={`transition-all duration-300 cursor-pointer rounded-lg ${
                            card.id === expandedCard 
                              ? 'bg-yellow-50 shadow-lg border-2 border-yellow-600 border-l-4 scale-105' 
                              : `bg-white shadow-md hover:shadow-lg hover:scale-102 border-l-4 ${card.borderColor}`
                          }`}
                          onClick={() => setExpandedCard(card.id)}
                        >
                          <div className="p-4">
                            <div className="flex items-center">
                              <div className={`w-8 h-8 rounded-full flex items-center justify-center mr-3 flex-shrink-0 ${
                                card.id === expandedCard ? 'bg-yellow-100' : card.bgColor
                              }`}>
                                {React.cloneElement(card.icon, { 
                                  className: `w-4 h-4 ${
                                    card.id === expandedCard ? 'text-yellow-700' : 'text-slate-700'
                                  }`
                                })}
                              </div>
                              <h3 className={`text-sm font-semibold ${
                                card.id === expandedCard ? 'text-yellow-800' : 'text-slate-800'
                              }`}>{card.title}</h3>
                              {card.id === expandedCard && (
                                <div className="ml-auto">
                                  <div className="w-2 h-2 bg-yellow-600 rounded-full"></div>
                                </div>
                              )}
                            </div>
                          </div>
                        </div>
                      </motion.div>
                    ))}
                  </div>
                  
                  {/* Right column - Expanded card */}
                  <div className="lg:col-span-2">
                    <motion.div
                      initial={{ opacity: 0, x: 20 }}
                      animate={{ opacity: 1, x: 0 }}
                      transition={{ duration: 0.3 }}
                      className="h-full"
                    >
                      <div className={`border-l-4 ${expandedCardData.borderColor} bg-white shadow-xl rounded-lg h-full flex flex-col`}>
                        <div className="p-8 flex-1 flex flex-col justify-between">
                          <div className="flex items-center mb-6">
                            <div className={`w-16 h-16 ${expandedCardData.bgColor} rounded-full flex items-center justify-center mr-6`}>
                              {React.cloneElement(expandedCardData.icon, { className: 'w-8 h-8' })}
                            </div>
                            <h3 className="text-2xl font-bold text-blue-800">{expandedCardData.title}</h3>
                          </div>
                          <p className="text-gray-700 leading-relaxed mb-6 text-base text-justify">
                            {expandedCardData.description}
                          </p>
                          <div className="border-t pt-6">
                            <p className="text-gray-600 leading-relaxed text-justify">
                              {expandedCardData.details}
                            </p>
                          </div>
                          <div className="flex justify-start mt-8">
                            <button 
                              onClick={() => setExpandedCard(null)}
                              className="flex items-center text-sm text-blue-600 hover:text-blue-800 transition-colors"
                            >
                              <ChevronLeft className="w-4 h-4 mr-1" />
                              Back to Overview
                            </button>
                          </div>
                        </div>
                      </div>
                    </motion.div>
                  </div>
                </div>
              );
            }
          })()}
          
          <motion.div 
            initial={{ opacity: 0, y: 20 }} 
            whileInView={{ opacity: 1, y: 0 }} 
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <div className="border-l-4 border-yellow-600 bg-white shadow-lg hover:shadow-xl transition-all duration-300 rounded-lg p-6">
              <p className="text-gray-700 leading-relaxed text-xl text-justify font-light">
                Above all, I prioritize trust, transparency, and long-term client relationships. My clients rely on me not just 
                as a lawyer, but as a dependable advisor who takes ownership of the challenges they face and remains steadfastly 
                committed to achieving the best possible outcomes.
              </p>
            </div>
          </motion.div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="relative -mt-10 py-20 px-6 bg-white">
        <div className="absolute -top-20 left-1/4 w-96 h-96 bg-slate-900/5 rounded-full blur-3xl"></div>
        <div className="max-w-6xl mx-auto relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 20 }} 
            whileInView={{ opacity: 1, y: 0 }} 
            transition={{ duration: 0.8 }}
            className="text-center mb-16"
          >
            <h2 className="text-5xl font-light text-slate-800 mb-4 tracking-wide">
              Services
            </h2>
            <div className="w-24 h-0.5 bg-yellow-600 mx-auto mb-6"></div>
            <p className="text-xl text-gray-600 font-light">Comprehensive Legal Solutions</p>
          </motion.div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              {
                id: 'legal-opinions',
                icon: <Scale className="w-6 h-6" />,
                title: "Legal Opinions & Research",
                description: "Well-reasoned legal opinions supported by statutory interpretation.",
                details: "I provide well-reasoned legal opinions supported by in-depth statutory interpretation and case law analysis. Each opinion is carefully tailored to the specific facts and legal issues at hand, enabling clients to make informed decisions while ensuring compliance with prevailing legal frameworks."
              },
              {
                id: 'contract-drafting',
                icon: <FileText className="w-6 h-6" />,
                title: "Legal Drafting & Documentation",
                description: "Comprehensive legal document preparation and vetting.",
                details: "Preparation and vetting of a wide range of legal documents, including Commercial Agreements, Wills & Codicils, Memoranda of Understanding, and Property Deeds. All documents are crafted to be clear, enforceable, and aligned with client-specific needs while minimizing legal exposure."
              },
              {
                id: 'retainership',
                icon: <Users className="w-6 h-6" />,
                title: "Retainership Services",
                description: "Ongoing legal counsel for corporate clients.",
                details: "As legal counsel on record for several business houses, I offer retainership services including day-to-day legal advisory, compliance tracking, risk assessment, and contract negotiation. This ensures businesses remain proactive, legally compliant, and commercially agile."
              },
              {
                id: 'legal-opinions-research',
                icon: <Scale className="w-6 h-6" />,
                title: "Legal Opinions & Research",
                description: "Well-reasoned legal opinions supported by statutory interpretation.",
                details: "I provide well-reasoned legal opinions supported by in-depth statutory interpretation and case law analysis. Each opinion is carefully tailored to the specific facts and legal issues at hand, enabling clients to make informed decisions while ensuring compliance with prevailing legal frameworks."
              },
              {
                id: 'dispute-resolution',
                icon: <Mail className="w-6 h-6" />,
                title: "Dispute Resolution & Negotiation",
                description: "Structured negotiation, mediation, and arbitration services.",
                details: "Assisting clients in resolving disputes through structured negotiation, mediation, and arbitration. My focus is on achieving favorable outcomes efficiently, minimizing litigation risk while safeguarding client interests."
              },
              {
                id: 'real-estate-rera',
                icon: <MapPin className="w-6 h-6" />,
                title: "Real Estate & Compliance",
                description: "Specialized legal assistance for real estate transactions.",
                details: "Providing specialized legal assistance to promoters, allottees, and agents on real estate transactions, RERA registrations, builder-buyer agreements, possession delays, and regulatory redressal. My services ensure compliance and timely resolution in property-related disputes."
              },
              {
                id: 'corporate-legal-advisory',
                icon: <ChevronRight className="w-6 h-6" />,
                title: "Corporate Legal Advisory",
                description: "Comprehensive advisory for corporate entities and governance.",
                details: "Comprehensive advisory for corporate entities on company formation, regulatory compliance, governance frameworks, mergers and acquisitions, and contract negotiations. My counsel is tailored to support legally secure and commercially sound decision-making."
              },
              {
                id: 'audit-tax',
                icon: <FileText className="w-6 h-6" />,
                title: "Audit & Tax Advisory",
                description: "Financial compliance and tax planning services.",
                details: "Leveraging my chartered accountancy background, I advise on statutory and internal audits, income tax planning, GST compliance, and financial risk assessment. These services ensure clients operate with financial clarity and regulatory peace of mind."
              },
              {
                id: 'business-improvement',
                icon: <Users className="w-6 h-6" />,
                title: "Business Process Improvement",
                description: "Operational and legal structuring for growth.",
                details: "Advisory on operational, legal, and structural improvements including SOP development, corporate governance compliance, business model restructuring, and risk-control matrix design. This service bridges law, finance, and strategy for sustainable growth."
              }
            ].map((service, index) => (
              <motion.div
                key={service.id}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: index * 0.1 }}
              >
                <div 
                  className="bg-white rounded-lg shadow-md cursor-pointer transition-all duration-300 border-l-4 border-slate-600 hover:border-yellow-600 hover:shadow-lg hover:scale-105 hover:-translate-y-1 h-full p-6 flex flex-col"
                  onClick={() => setServiceModal(service)}
                >
                    <div className="flex items-center mb-4">
                      <div className="w-12 h-12 bg-slate-100 rounded-full flex items-center justify-center mr-4">
                        {React.cloneElement(service.icon, { className: 'w-6 h-6 text-slate-700' })}
                      </div>
                      <h3 className="text-lg font-light tracking-wide text-slate-800">{service.title}</h3>
                    </div>
                    <p className="text-gray-700 leading-relaxed text-sm flex-1">{service.description}</p>
                    <div className="text-center mt-4">
                      <span className="text-xs text-gray-400">Click to learn more</span>
                    </div>
                </div>
              </motion.div>
            ))}
          </div>
          
      {/* Service Detail Modal */}
          {serviceModal && (
            <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 overflow-x-hidden">
              <div className="bg-white rounded-lg p-6 md:p-8 w-full max-w-2xl mx-4 max-h-[80vh] overflow-y-auto">
                <div className="flex items-center mb-6">
                  <div className="w-12 md:w-16 h-12 md:h-16 bg-yellow-100 rounded-full flex items-center justify-center mr-4 md:mr-6 flex-shrink-0">
                    {React.cloneElement(serviceModal.icon, { className: 'w-6 md:w-8 h-6 md:h-8 text-yellow-700' })}
                  </div>
                  <h3 className="text-xl md:text-3xl font-light text-slate-800">{serviceModal.title}</h3>
                </div>
                <p className="text-gray-600 leading-relaxed mb-4 text-sm md:text-base">{serviceModal.description}</p>
                <div className="border-t pt-4">
                  <p className="text-gray-700 leading-relaxed text-justify text-sm md:text-base">{serviceModal.details}</p>
                </div>
                <div className="flex flex-col sm:flex-row justify-between items-center mt-8 gap-3">
                  <div className="flex flex-col sm:flex-row gap-3 w-full sm:w-auto">
                    <Button 
                      onClick={() => {
                        setServiceModal(null);
                        handleConsultation();
                      }} 
                      className="bg-yellow-600 hover:bg-yellow-700 text-white px-4 md:px-6 py-2 text-sm"
                    >
                      Book Consultation
                    </Button>
                    <Button 
                      onClick={() => {
                        setServiceModal(null);
                        handleWhatsApp();
                      }} 
                      className="bg-green-600 hover:bg-green-700 text-white px-4 md:px-6 py-2 text-sm"
                    >
                      WhatsApp
                    </Button>
                  </div>
                  <Button onClick={() => setServiceModal(null)} className="bg-slate-800 hover:bg-slate-900 text-white px-4 md:px-6 py-2 text-sm w-full sm:w-auto">
                    Close
                  </Button>
                </div>
              </div>
            </div>
          )}
        </div>
      </section>

      {/* Professional Experience Section */}
      <section id="professional-experience" className="relative py-20 px-6 bg-gradient-to-br from-blue-50 to-slate-50">
        <div className="max-w-6xl mx-auto">
          <motion.div
            initial={{ opacity: 0, y: 20 }} 
            whileInView={{ opacity: 1, y: 0 }} 
            transition={{ duration: 0.8 }}
            className="text-center mb-16"
          >
            <h2 className="text-5xl font-light text-slate-800 mb-4 tracking-wide">
              Forum-wise Experience
            </h2>
            <div className="w-24 h-0.5 bg-yellow-600 mx-auto mb-6"></div>
            <p className="text-xl text-gray-600 font-light">Expertise Across Multiple Judicial Forums</p>
          </motion.div>
          
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[
              {
                id: 'high-court',
                icon: <Scale className="w-6 h-6" />,
                title: "High Court",
                subtitle: "",
                description: "Regularly appear before the Hon'ble High Court in matters involving writ petitions, civil and tax appeals, and constitutional challenges. Adept at handling complex legal issues requiring nuanced statutory interpretation and procedural precision."
              },
              {
                id: 'nclt',
                icon: <Users className="w-6 h-6" />,
                title: "National Company Law Tribunal",
                subtitle: "(NCLT)",
                description: "Actively represent corporate clients, financial institutions, and operational creditors in proceedings under the Insolvency and Bankruptcy Code (IBC). Experience includes initiating and defending insolvency petitions."
              },
              {
                id: 'drt',
                icon: <FileText className="w-6 h-6" />,
                title: "Debts Recovery Tribunal",
                subtitle: "(DRT)",
                description: "Advocate for both banks and borrowers in proceedings under the Recovery of Debts and Bankruptcy Act and SARFAESI Act. Expertise in filing and contesting Original Applications and Securitisation Applications."
              },
              {
                id: 'consumer-commission',
                icon: <ChevronRight className="w-6 h-6" />,
                title: "Consumer Disputes Commission",
                subtitle: "",
                description: "Represent consumers and service providers in high-value claims involving real estate, financial products, and service deficiency. Handle both original complaints and appeals with meticulous document presentation."
              },
              {
                id: 'rera',
                icon: <MapPin className="w-6 h-6" />,
                title: "Real Estate Regulatory Authority",
                subtitle: "(RERA)",
                description: "Provide end-to-end legal assistance to promoters, allottees, and real estate agents on RERA compliance, project registration, and enforcement of builder-buyer agreements."
              },
              {
                id: 'district-courts',
                icon: <Mail className="w-6 h-6" />,
                title: "District & Sessions Courts",
                subtitle: "(Across Rajasthan)",
                description: "Appear regularly before civil, criminal, and commercial benches across various district courts. Handle property disputes, contract enforcement, criminal defence, and cheque dishonour cases."
              }
            ].map((forum, index) => (
              <motion.div
                key={forum.id}
                initial={{ opacity: 0, y: 20 }}
                whileInView={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.8, delay: index * 0.1 }}
              >
                <div className="bg-white rounded-lg shadow-lg p-6 border-l-4 border-yellow-600 hover:shadow-xl hover:scale-105 hover:-translate-y-1 transition-all duration-300 h-full flex flex-col">
                  <div className="flex items-center mb-4 min-h-[80px]">
                    <div className="w-12 h-12 bg-yellow-100 rounded-full flex items-center justify-center mr-4 flex-shrink-0">
                      {React.cloneElement(forum.icon, { className: 'w-6 h-6 text-yellow-700' })}
                    </div>
                    <div className="flex-1">
                      <h3 className="text-lg font-semibold text-slate-800 leading-tight">{forum.title}</h3>
                      {forum.subtitle && <p className="text-sm text-yellow-700 font-medium mt-1">{forum.subtitle}</p>}
                    </div>
                  </div>
                  <p className="text-gray-700 leading-snug text-justify flex-1">{forum.description}</p>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* About Me Section */}
      <section id="about-me" className="py-20 px-6 bg-slate-50 relative">
        <div className="absolute inset-0 bg-gradient-to-r from-transparent via-yellow-600/5 to-transparent"></div>
        <div className="max-w-6xl mx-auto relative">
          <motion.div
            initial={{ opacity: 0, y: 20 }} 
            whileInView={{ opacity: 1, y: 0 }} 
            transition={{ duration: 0.8 }}
            className="text-center mb-16"
          >
            <h2 className="text-5xl font-light text-slate-800 mb-4 tracking-wide">
              About Me
            </h2>
            <div className="w-24 h-0.5 bg-yellow-400 mx-auto mb-6"></div>
            <p className="text-xl text-gray-600 font-light">Professional Background</p>
          </motion.div>
          
          <div className="grid lg:grid-cols-12 gap-8 mb-16" style={{overflow: 'visible'}}>
            <div className="lg:col-span-4 lg:col-start-2">
              <div style={{position: 'sticky', top: '6rem'}}>
                <div className="relative">
                  <div className="w-full h-96 bg-gradient-to-br from-slate-100 to-slate-200 rounded-3xl overflow-hidden shadow-2xl">
                    <img 
                      src="./aboutme.png" 
                      alt="About Meyhul Miittal" 
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute bottom-0 left-0 right-0 h-1/3 bg-gradient-to-t from-slate-800/90 to-transparent flex items-end p-6">
                      <div className="text-white">
                        <h3 className="text-2xl font-light mb-2">Meyhul Miittal</h3>
                        <p className="text-slate-200">Advocate & Legal Consultant</p>
                      </div>
                    </div>
                  </div>
                  <div className="absolute -top-6 -right-6 w-20 h-20 bg-yellow-600 rounded-full flex items-center justify-center shadow-lg">
                    <Mail className="w-10 h-10 text-white" />
                  </div>
                </div>
              </div>
            </div>
            
            <div className="lg:col-span-6 lg:col-start-7 space-y-6">
              <div className="bg-white rounded-2xl p-6 shadow-lg">
                <h4 className="text-xl font-medium text-slate-800 mb-4 flex items-center">
                  <div className="w-3 h-3 bg-yellow-600 rounded-full mr-3"></div>
                  Professional Background
                </h4>
                <p className="text-gray-700 leading-relaxed text-justify mb-4">
                  I am a dedicated legal professional with a multidisciplinary background spanning law, finance, and business advisory. My practice is rooted in integrity, strategic thinking, and a commitment to delivering effective, client-focused legal solutions.
                </p>
                <p className="text-gray-700 leading-relaxed text-justify">
                  Based in Jaipur, Rajasthan, I represent clients across a wide spectrum of judicial and quasi-judicial forums, including the Hon'ble High Court of Rajasthan, National Company Law Tribunal (NCLT), Debts Recovery Tribunal (DRT), Real Estate Regulatory Authority (RERA), Consumer Forums, and District & Sessions Courts.
                </p>
              </div>
              
              <div className="bg-white rounded-2xl p-6 shadow-lg">
                <h4 className="text-xl font-medium text-slate-800 mb-4 flex items-center">
                  <div className="w-3 h-3 bg-yellow-600 rounded-full mr-3"></div>
                  Expertise & Clientele
                </h4>
                <p className="text-gray-700 leading-relaxed text-justify mb-4">
                  My clientele includes individuals, startups, corporations, and institutions from diverse sectors such as real estate, education, hospitality, manufacturing, and financial services. I specialize in legal advisory, commercial litigation, contract drafting, dispute resolution, and regulatory compliance.
                </p>
                <p className="text-gray-700 leading-relaxed text-justify">
                  My ability to combine legal expertise with financial insight enables me to offer holistic, actionable advice aligned with both legal mandates and business realities.
                </p>
              </div>
              
              <div className="bg-white rounded-2xl p-6 shadow-lg">
                <h4 className="text-xl font-medium text-slate-800 mb-4 flex items-center">
                  <div className="w-3 h-3 bg-yellow-600 rounded-full mr-3"></div>
                  Professional Journey
                </h4>
                <p className="text-gray-700 leading-relaxed text-justify mb-4">
                  Earlier in my career, I gained valuable experience through my association with a reputed chartered accountancy firm, where I was actively involved in audits, taxation, and management consultancy. I also work in close collaboration with various Advocates and professionals.
                </p>
                <p className="text-gray-700 leading-relaxed text-justify">
                  My approach is pragmatic, research-driven, and solution-oriented. I prioritize clear communication, ethical advocacy, and long-term client relationships—delivering legal support that is both trustworthy and results-focused.
                </p>
              </div>
            </div>
          </div>
          
          <div className="bg-slate-50 rounded-lg p-8">
            <div className="grid md:grid-cols-2 gap-12">
              <div>
                <div className="flex items-center mb-6">
                  <div className="w-12 h-12 bg-yellow-600 rounded-full flex items-center justify-center mr-4">
                    <FileText className="w-6 h-6 text-white" />
                  </div>
                  <h3 className="text-2xl font-light text-slate-800 tracking-wide">Education & Qualifications</h3>
                </div>
                <div className="space-y-3">
                  {[
                    {
                      title: "LL.M. (Corporate & Commercial Law)",
                      institution: "Apex School of Law, Apex University, Jaipur",
                      details: "A postgraduate specialization focused on advanced corporate law, commercial contracts, mergers and acquisitions, and regulatory compliance. This degree has strengthened my ability to advise clients on complex business transactions and legal structuring with clarity and precision."
                    },
                    {
                      title: "LL.B.",
                      institution: "Apex School of Law, Apex University, Jaipur",
                      details: "My foundational legal education encompassing core areas such as constitutional law, civil and criminal procedure, contract law, evidence, and property law. This degree laid the groundwork for my litigation practice and honed my understanding of India's legal system."
                    },
                    {
                      title: "B.B.A.",
                      institution: "University Commerce College, University of Rajasthan, Jaipur",
                      details: "An undergraduate degree in business administration, which provided me with key insights into finance, management, organizational behavior, and strategic planning. This commercial acumen complements my legal practice, particularly when advising corporate clients."
                    },
                    {
                      title: "C.A. Finalist",
                      institution: "Institute of Chartered Accountants of India",
                      details: "Having cleared the intermediate level and completed the required articleship, I possess a strong command over financial reporting, auditing, taxation, and business law. This training empowers me to provide legally sound and fiscally responsible solutions across both litigation and advisory mandates."
                    },
                    {
                      title: "Enrolled with Bar Council of India",
                      institution: "Professional Legal Practice Authorization",
                      details: "Enrolled as an Advocate with the Bar Council of India, authorized to practice law across all courts and tribunals in India. This enrollment ensures adherence to professional ethics, continuing legal education, and maintaining the highest standards of legal practice as mandated by the Advocates Act, 1961."
                    }
                  ].map((qualification, index) => (
                    <div 
                      key={index}
                      className="flex items-center justify-between p-3 bg-white rounded-lg shadow-sm cursor-pointer hover:shadow-md transition-all duration-200 hover:bg-yellow-50"
                      onClick={() => setQualificationModal(qualification)}
                    >
                      <div className="flex items-center">
                        <FileText className="w-4 h-4 text-yellow-600 mr-3" />
                        <span className="text-gray-700">
                          {qualification.title === "LL.M. (Corporate & Commercial Law)" ? "Master of Laws (LL.M.)" :
                           qualification.title === "LL.B." ? "Bachelor of Laws (LL.B.)" :
                           qualification.title === "B.B.A." ? "Bachelor of Business Administration (B.B.A.)" :
                           qualification.title}
                        </span>
                      </div>
                      <ChevronRight className="w-4 h-4 text-gray-400" />
                    </div>
                  ))}
                </div>
                
                <div className="flex items-center mb-6 mt-8">
                  <div className="w-12 h-12 bg-yellow-600 rounded-full flex items-center justify-center mr-4">
                    <Scale className="w-6 h-6 text-white" />
                  </div>
                  <h3 className="text-2xl font-light text-slate-800 tracking-wide">Practice Philosophy</h3>
                </div>
                <div className="bg-white rounded-lg p-6 shadow-sm">
                  <p className="text-gray-700 leading-relaxed text-justify">
                    My practice is founded on the principles of integrity, diligence, and client-focused service. 
                    I strive to make legal processes accessible and understandable while maintaining the highest 
                    standards of professional conduct as mandated by the Bar Council of India.
                  </p>
                </div>
              </div>
              
              <div>
                <div className="flex items-center mb-6">
                  <div className="w-12 h-12 bg-yellow-600 rounded-full flex items-center justify-center mr-4">
                    <Users className="w-6 h-6 text-white" />
                  </div>
                  <h3 className="text-2xl font-light text-slate-800 tracking-wide">Key Practice Areas</h3>
                </div>
                <div className="space-y-3">
                  {[
                    {
                      title: "Litigation & Representation",
                      description: "Skilled representation before judicial and quasi-judicial forums.",
                      details: "Skilled representation before the Hon'ble High Court of Rajasthan, NCLT, DRT, RERA, and various other judicial and quasi-judicial forums. I handle complex civil, commercial, and constitutional matters with a strategic, research-driven approach to litigation."
                    },
                    {
                      title: "Legal Drafting & Documentation",
                      description: "Comprehensive legal document preparation and vetting.",
                      details: "Preparation and vetting of a wide range of legal documents, including Commercial Agreements, Wills & Codicils, Memoranda of Understanding, and Property Deeds. All documents are crafted to be clear, enforceable, and aligned with client-specific needs while minimizing legal exposure."
                    },
                    {
                      title: "Retainership Services",
                      description: "Ongoing legal counsel for corporate clients.",
                      details: "As legal counsel on record for several business houses, I offer retainership services including day-to-day legal advisory, compliance tracking, risk assessment, and contract negotiation. This ensures businesses remain proactive, legally compliant, and commercially agile."
                    },
                    {
                      title: "Legal Opinions & Research",
                      description: "Well-reasoned legal opinions supported by statutory interpretation.",
                      details: "I provide well-reasoned legal opinions supported by in-depth statutory interpretation and case law analysis. Each opinion is carefully tailored to the specific facts and legal issues at hand, enabling clients to make informed decisions while ensuring compliance with prevailing legal frameworks."
                    },
                    {
                      title: "Dispute Resolution & Negotiation",
                      description: "Structured negotiation, mediation, and arbitration services.",
                      details: "Assisting clients in resolving disputes through structured negotiation, mediation, and arbitration. My focus is on achieving favorable outcomes efficiently, minimizing litigation risk while safeguarding client interests."
                    },
                    {
                      title: "Real Estate & Compliance",
                      description: "Specialized legal assistance for real estate transactions.",
                      details: "Providing specialized legal assistance to promoters, allottees, and agents on real estate transactions, RERA registrations, builder-buyer agreements, possession delays, and regulatory redressal. My services ensure compliance and timely resolution in property-related disputes."
                    },
                    {
                      title: "Corporate Legal Advisory",
                      description: "Comprehensive advisory for corporate entities and governance.",
                      details: "Comprehensive advisory for corporate entities on company formation, regulatory compliance, governance frameworks, mergers and acquisitions, and contract negotiations. My counsel is tailored to support legally secure and commercially sound decision-making."
                    },
                    {
                      title: "Audit & Tax Advisory",
                      description: "Financial compliance and tax planning services.",
                      details: "Leveraging my chartered accountancy background, I advise on statutory and internal audits, income tax planning, GST compliance, and financial risk assessment. These services ensure clients operate with financial clarity and regulatory peace of mind."
                    },
                    {
                      title: "Business Process Improvement",
                      description: "Operational and legal structuring for growth.",
                      details: "Advisory on operational, legal, and structural improvements including SOP development, corporate governance compliance, business model restructuring, and risk-control matrix design. This service bridges law, finance, and strategy for sustainable growth."
                    }
                  ].map((area, index) => (
                    <div 
                      key={index} 
                      className="flex items-center justify-between p-3 bg-white rounded-lg shadow-sm cursor-pointer hover:shadow-md transition-all duration-200 hover:bg-yellow-50"
                      onClick={() => setPracticeAreaModal(area)}
                    >
                      <div className="flex items-center">
                        <Scale className="w-4 h-4 text-yellow-600 mr-3" />
                        <span className="text-gray-700">{area.title}</span>
                      </div>
                      <ChevronRight className="w-4 h-4 text-gray-400" />
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Practice Area Detail Modal */}
      {practiceAreaModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 overflow-x-hidden">
          <div className="bg-white rounded-lg p-6 md:p-8 w-full max-w-2xl mx-4 max-h-[80vh] overflow-y-auto">
            <div className="flex items-center mb-6">
              <div className="w-12 md:w-16 h-12 md:h-16 bg-yellow-100 rounded-full flex items-center justify-center mr-4 md:mr-6 flex-shrink-0">
                <Users className="w-6 md:w-8 h-6 md:h-8 text-yellow-700" />
              </div>
              <div className="min-w-0">
                <h3 className="text-lg md:text-2xl font-semibold text-slate-800 leading-tight">{practiceAreaModal.title}</h3>
                <p className="text-base md:text-lg text-yellow-700 font-medium">{practiceAreaModal.description}</p>
              </div>
            </div>
            <div className="border-t pt-4">
              <p className="text-gray-700 leading-relaxed text-justify text-sm md:text-base">{practiceAreaModal.details}</p>
            </div>
            <div className="flex flex-col sm:flex-row justify-between items-center mt-8 gap-3">
              <div className="flex flex-col sm:flex-row gap-3 w-full sm:w-auto">
                <Button 
                  onClick={() => {
                    setPracticeAreaModal(null);
                    handleConsultation();
                  }} 
                  className="bg-yellow-600 hover:bg-yellow-700 text-white px-4 md:px-6 py-2 text-sm"
                >
                  Book Consultation
                </Button>
                <Button 
                  onClick={() => {
                    setPracticeAreaModal(null);
                    handleWhatsApp();
                  }} 
                  className="bg-green-600 hover:bg-green-700 text-white px-4 md:px-6 py-2 text-sm"
                >
                  WhatsApp
                </Button>
              </div>
              <Button onClick={() => setPracticeAreaModal(null)} className="bg-slate-800 hover:bg-slate-900 text-white px-4 md:px-6 py-2 text-sm w-full sm:w-auto">
                Close
              </Button>
            </div>
          </div>
        </div>
      )}

      {/* Qualification Detail Modal */}
      {qualificationModal && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 overflow-x-hidden">
          <div className="bg-white rounded-lg p-6 md:p-8 w-full max-w-2xl mx-4 max-h-[80vh] overflow-y-auto">
            <div className="flex items-center mb-6">
              <div className="w-12 md:w-16 h-12 md:h-16 bg-yellow-100 rounded-full flex items-center justify-center mr-4 md:mr-6 flex-shrink-0">
                <FileText className="w-6 md:w-8 h-6 md:h-8 text-yellow-700" />
              </div>
              <div className="min-w-0">
                <h3 className="text-lg md:text-2xl font-semibold text-slate-800 leading-tight">{qualificationModal.title}</h3>
                <p className="text-base md:text-lg text-yellow-700 font-medium break-words">{qualificationModal.institution}</p>
              </div>
            </div>
            <div className="border-t pt-4">
              <p className="text-gray-700 leading-relaxed text-justify text-sm md:text-base">{qualificationModal.details}</p>
            </div>
            <div className="flex justify-end mt-8">
              <Button onClick={() => setQualificationModal(null)} className="bg-slate-800 hover:bg-slate-900 text-white px-4 md:px-6 py-2 text-sm">
                Close
              </Button>
            </div>
          </div>
        </div>
      )}

      {/* About Us Section */}
      <section id="about" className="relative py-20 px-6 bg-white -mt-16">
        <div className="absolute top-0 left-0 w-1/2 h-32 bg-gradient-to-r from-slate-50 to-transparent"></div>
        <div className="max-w-6xl mx-auto relative z-10">
          <motion.div
            initial={{ opacity: 0, y: 20 }} 
            whileInView={{ opacity: 1, y: 0 }} 
            transition={{ duration: 0.8 }}
            className="text-center mb-16"
          >
            <h2 className="text-5xl font-light text-slate-800 mb-4 tracking-wide">
              Legal Practice in India
            </h2>
            <div className="w-24 h-0.5 bg-yellow-400 mx-auto mb-6"></div>
            <p className="text-xl text-gray-600 font-light">Understanding the System</p>
          </motion.div>
          
          <div className="grid md:grid-cols-2 gap-8 mb-12">
            <Card className="border-l-4 border-yellow-400 shadow-lg">
              <CardContent className="p-8">
                <h3 className="text-2xl font-light mb-6 text-slate-800 tracking-wide">The Indian Advocate System</h3>
                <p className="text-gray-700 leading-relaxed text-justify">
                  In India, an Advocate is a legal professional qualified to represent clients in courts of law. 
                  The profession is governed by the Advocates Act, 1961, and regulated by the Bar Council of India. 
                  Advocates must be enrolled with the State Bar Council and can practice in various courts including 
                  District Courts, High Courts, and the Supreme Court of India.
                </p>
              </CardContent>
            </Card>
            
            <Card className="border-l-4 border-yellow-400 shadow-lg">
              <CardContent className="p-8">
                <h3 className="text-2xl font-light mb-6 text-slate-800 tracking-wide">Professional Excellence</h3>
                <p className="text-gray-700 leading-relaxed text-justify">
                  Indian Advocates are required to maintain high standards of professional conduct and ethics. 
                  With qualifications including LL.B. (Bachelor of Laws) and advanced degrees like LL.M. (Master of Laws), 
                  advocates provide comprehensive legal services ranging from litigation to corporate advisory, 
                  ensuring justice and legal compliance for individuals and businesses.
                </p>
              </CardContent>
            </Card>
          </div>
          
          <Card className="bg-slate-50 border-2 border-yellow-400 shadow-lg">
            <CardContent className="p-8">
              <h3 className="text-3xl font-light mb-6 text-slate-800 text-center tracking-wide">Our Commitment to Justice</h3>
              <p className="text-gray-800 leading-relaxed text-justify max-w-3xl mx-auto">
                As a qualified Advocate with B.B.A., LL.B., and LL.M. credentials, Meyhul Miittal brings extensive 
                knowledge of Indian law and legal procedures. Our practice is built on the foundation of integrity, 
                professional excellence, and unwavering commitment to protecting our clients' rights and interests 
                within the framework of Indian jurisprudence.
              </p>
            </CardContent>
          </Card>
        </div>
      </section>

      {/* Contact Section */}
      <section id="contact" className="relative py-20 px-6 bg-slate-900 text-white transform -skew-y-1 mt-20">
        <div className="absolute inset-0 bg-gradient-to-br from-slate-800 to-black skew-y-1"></div>
        <div className="max-w-6xl mx-auto relative z-10 skew-y-1">
          <motion.div
            initial={{ opacity: 0, y: 20 }} 
            whileInView={{ opacity: 1, y: 0 }} 
            transition={{ duration: 0.8 }}
            className="text-center mb-16"
          >
            <h2 className="text-5xl font-light text-white mb-4 tracking-wide">
              Get in Touch
            </h2>
            <div className="w-24 h-0.5 bg-yellow-400 mx-auto mb-6"></div>
            <p className="text-xl text-gray-300 font-light">Reach Out for Hassle-Free Consultation</p>
          </motion.div>
          
          <div className="grid md:grid-cols-2 gap-8 text-center">
            <Card className="bg-white/10 border-white/20">
              <CardContent className="text-center p-6">
                <Phone className="w-8 h-8 text-yellow-400 mx-auto mb-4" />
                <h3 className="text-xl font-semibold mb-2">Call Us</h3>
                <p className="text-gray-300">+91 9928228793</p>
                <Button onClick={() => window.open('tel:+919928228793')} className="mt-4 bg-yellow-400 text-black hover:bg-yellow-500">Call Now</Button>
              </CardContent>
            </Card>
            
            <Card className="bg-white/10 border-white/20">
              <CardContent className="text-center p-6">
                <Mail className="w-8 h-8 text-yellow-400 mx-auto mb-4" />
                <h3 className="text-xl font-semibold mb-2">Email Us</h3>
                <p className="text-gray-300">meyhul@outlook.com</p>
                <Button onClick={() => window.open('mailto:meyhul@outlook.com?subject=Legal Consultation Inquiry')} className="mt-4 bg-yellow-400 text-black hover:bg-yellow-500">Send Email</Button>
              </CardContent>
            </Card>
          </div>
        </div>
      </section>

      {/* Back to Top Button */}
      <button 
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        className="fixed bottom-6 right-6 bg-yellow-600 hover:bg-yellow-700 text-white p-3 rounded-full shadow-lg hover:shadow-xl transition-all duration-300 hover:scale-110 z-40"
        style={{ display: showFixedNav ? 'block' : 'none' }}
      >
        <ChevronLeft className="w-5 h-5 rotate-90" />
      </button>

      {/* FAQ Modal */}
      {showFAQ && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 overflow-x-hidden">
          <div className="bg-white rounded-lg p-6 md:p-8 w-full max-w-4xl mx-4 max-h-[80vh] overflow-y-auto">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-2xl md:text-3xl font-light text-slate-800">Frequently Asked Questions</h2>
              <Button onClick={() => setShowFAQ(false)} className="bg-slate-800 hover:bg-slate-900 text-white px-4 py-2 text-sm">
                Close
              </Button>
            </div>
            <div className="space-y-4">
              {[
                {
                  question: "What types of legal matters do you handle?",
                  answer: "I handle a wide range of legal matters including civil litigation, criminal defense, corporate law, real estate transactions, contract disputes, family law, and regulatory compliance across various forums including High Court, NCLT, DRT, RERA, and Consumer Forums."
                },
                {
                  question: "How do I schedule a consultation?",
                  answer: "You can schedule a consultation by clicking the 'Schedule Consultation' button, calling +91 9928228793, or sending a WhatsApp message. Initial consultations help determine the best approach for your legal matter."
                },
                {
                  question: "What should I bring to my first consultation?",
                  answer: "Please bring all relevant documents related to your case, including contracts, correspondence, court papers, property documents, or any other materials that pertain to your legal matter. A chronological summary of events is also helpful."
                },
                {
                  question: "What are your fees and payment structure?",
                  answer: "Legal fees vary based on the complexity and nature of the matter. I offer transparent fee structures including hourly rates, fixed fees for specific services, and retainer arrangements for ongoing legal counsel. Fee discussions are part of the initial consultation."
                },
                {
                  question: "Do you handle cases outside Rajasthan?",
                  answer: "While my primary practice is in Rajasthan, I can handle matters in other jurisdictions through local counsel arrangements or by obtaining special permissions as required by the respective courts and legal procedures."
                },
                {
                  question: "How long do legal proceedings typically take?",
                  answer: "The duration varies significantly based on the type of case, court jurisdiction, complexity of issues, and cooperation of parties involved. During consultation, I provide realistic timelines based on the specific circumstances of your matter."
                },
                {
                  question: "Can you help with business legal compliance?",
                  answer: "Yes, I provide comprehensive corporate legal services including company formation, regulatory compliance, contract drafting, employment law, and ongoing legal advisory through retainer arrangements for businesses of all sizes."
                },
                {
                  question: "What is your approach to dispute resolution?",
                  answer: "I believe in exploring all available options including negotiation, mediation, and arbitration before proceeding to litigation. My goal is to achieve the best possible outcome efficiently while protecting your interests and minimizing costs."
                }
              ].map((faq, index) => (
                <div key={index} className="border border-gray-200 rounded-lg">
                  <button
                    onClick={() => setExpandedFAQ(expandedFAQ === index ? null : index)}
                    className="w-full text-left p-4 hover:bg-gray-50 transition-colors duration-200 flex justify-between items-center"
                  >
                    <span className="font-medium text-slate-800">{faq.question}</span>
                    <ChevronRight className={`w-5 h-5 text-gray-400 transition-transform duration-200 ${expandedFAQ === index ? 'rotate-90' : ''}`} />
                  </button>
                  {expandedFAQ === index && (
                    <div className="px-4 pb-4 border-t border-gray-100">
                      <p className="text-gray-700 leading-relaxed pt-3">{faq.answer}</p>
                    </div>
                  )}
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Areas of Law Modal */}
      {showAreasOfLaw && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 overflow-x-hidden">
          <div className="bg-white rounded-lg p-6 md:p-8 w-full max-w-5xl mx-4 max-h-[80vh] overflow-y-auto">
            <div className="flex items-center justify-between mb-6">
              <h2 className="text-2xl md:text-3xl font-light text-slate-800">Areas of Law - Quick Reference</h2>
              <Button onClick={() => setShowAreasOfLaw(false)} className="bg-slate-800 hover:bg-slate-900 text-white px-4 py-2 text-sm">
                Close
              </Button>
            </div>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-4">
              {[
                {
                  title: "Civil Law",
                  definition: "Deals with disputes between individuals, organizations, or between the two, in which compensation is awarded to the victim.",
                  examples: "Property disputes, contract breaches, tort claims, family matters"
                },
                {
                  title: "Criminal Law",
                  definition: "Body of law that relates to crime and punishment of those who violate laws established by the state.",
                  examples: "Theft, fraud, assault, white-collar crimes, regulatory violations"
                },
                {
                  title: "Corporate Law",
                  definition: "Legal framework governing the formation, operation, and dissolution of corporations and business entities.",
                  examples: "Company formation, compliance, mergers, acquisitions, governance"
                },
                {
                  title: "Contract Law",
                  definition: "Legal principles governing agreements between parties, including formation, performance, and enforcement.",
                  examples: "Business agreements, employment contracts, service agreements"
                },
                {
                  title: "Property Law",
                  definition: "Legal rules governing ownership, use, and transfer of real and personal property.",
                  examples: "Real estate transactions, property disputes, landlord-tenant issues"
                },
                {
                  title: "Constitutional Law",
                  definition: "Body of law derived from the Constitution, dealing with fundamental rights and government powers.",
                  examples: "Fundamental rights violations, writ petitions, constitutional challenges"
                },
                {
                  title: "Administrative Law",
                  definition: "Legal principles governing the activities of administrative agencies and their relationship with citizens.",
                  examples: "Regulatory compliance, government decisions, administrative appeals"
                },
                {
                  title: "Tax Law",
                  definition: "Legal framework governing taxation, including income tax, GST, and other fiscal regulations.",
                  examples: "Tax planning, compliance, disputes with tax authorities"
                },
                {
                  title: "Labor Law",
                  definition: "Legal framework governing the relationship between employers, employees, and labor unions.",
                  examples: "Employment disputes, workplace rights, labor compliance"
                },
                {
                  title: "Consumer Law",
                  definition: "Legal protections for consumers in their transactions with businesses and service providers.",
                  examples: "Product defects, service deficiency, unfair trade practices"
                },
                {
                  title: "Banking Law",
                  definition: "Legal framework governing banking operations, financial institutions, and monetary transactions.",
                  examples: "Loan disputes, banking regulations, financial compliance"
                },
                {
                  title: "Insolvency Law",
                  definition: "Legal framework for dealing with individuals and companies unable to pay their debts.",
                  examples: "Corporate insolvency, debt recovery, bankruptcy proceedings"
                }
              ].map((area, index) => (
                <div key={index} className="h-full">
                  <div 
                    className="bg-gray-50 rounded-lg p-4 cursor-pointer hover:bg-yellow-50 hover:shadow-md transition-all duration-200 border-l-4 border-yellow-600 h-full flex flex-col"
                    onClick={() => setSelectedLegalArea(area)}
                  >
                    <div className="flex items-center justify-between mb-2">
                      <h3 className="font-semibold text-slate-800">{area.title}</h3>
                      <ChevronRight className="w-4 h-4 text-gray-400" />
                    </div>
                    <p className="text-gray-600 text-sm flex-1">Click to view definition and examples</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Legal Area Detail Modal */}
      {selectedLegalArea && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 overflow-x-hidden">
          <div className="bg-white rounded-lg p-6 md:p-8 w-full max-w-2xl mx-4 max-h-[80vh] overflow-y-auto">
            <div className="flex items-center justify-between mb-6">
              <h3 className="text-xl md:text-2xl font-semibold text-slate-800">{selectedLegalArea.title}</h3>
              <Button onClick={() => setSelectedLegalArea(null)} className="bg-slate-800 hover:bg-slate-900 text-white px-4 py-2 text-sm">
                Close
              </Button>
            </div>
            <div className="space-y-4">
              <div>
                <h4 className="font-medium text-slate-700 mb-2">Definition:</h4>
                <p className="text-gray-700 leading-relaxed">{selectedLegalArea.definition}</p>
              </div>
              <div>
                <h4 className="font-medium text-slate-700 mb-2">Examples:</h4>
                <p className="text-gray-600">{selectedLegalArea.examples}</p>
              </div>
            </div>
          </div>
        </div>
      )}
      <footer className="text-center text-sm text-gray-500 py-6 border-t bg-white">
        <div className="max-w-4xl mx-auto px-6">
          <p className="mb-2">© 2026 Meyhul Miittal. All rights reserved.</p>
          <p className="text-xs text-gray-400">
            Disclaimer: This website is intended solely for informational purposes in compliance with BCI Rules.
          </p>
        </div>
      </footer>

      {/* Consultation Modal */}
      {showModal && !showDisclaimer && (
        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4 overflow-x-hidden">
          <div className="bg-white rounded-lg p-6 w-full max-w-md mx-4 max-h-[90vh] overflow-y-auto">
            <h3 className="text-xl md:text-2xl font-bold mb-4 text-blue-900">Book a Consultation</h3>
            <form onSubmit={handleFormSubmit}>
              <div className="mb-4">
                <label className="block text-gray-700 text-sm font-bold mb-2">Name *</label>
                <input
                  type="text"
                  required
                  value={formData.name}
                  onChange={(e) => setFormData({...formData, name: e.target.value})}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-blue-500 text-sm"
                />
              </div>
              <div className="mb-4">
                <label className="block text-gray-700 text-sm font-bold mb-2">Phone Number *</label>
                <div className="flex gap-2">
                  <select
                    value={formData.countryCode}
                    onChange={(e) => setFormData({...formData, countryCode: e.target.value})}
                    className="px-2 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-blue-500 text-sm min-w-0 flex-shrink-0"
                    style={{maxWidth: '80px'}}
                  >
                    {countryCodes.map((country) => (
                      <option key={country.code} value={country.code}>
                        {country.code}
                      </option>
                    ))}
                  </select>
                  <input
                    type="tel"
                    required
                    value={formData.phone}
                    onChange={handlePhoneChange}
                    placeholder="10 digits only"
                    maxLength="10"
                    className="flex-1 min-w-0 px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-blue-500 text-sm"
                  />
                </div>
                <p className="text-xs text-gray-500 mt-1">Enter 10 digits without country code</p>
              </div>
              <div className="mb-4">
                <label className="block text-gray-700 text-sm font-bold mb-2">Email Address *</label>
                <input
                  type="email"
                  required
                  value={formData.email}
                  onChange={(e) => setFormData({...formData, email: e.target.value})}
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-blue-500 text-sm"
                />
              </div>
              <div className="mb-6">
                <label className="block text-gray-700 text-sm font-bold mb-2">Your Query *</label>
                <textarea
                  required
                  value={formData.query}
                  onChange={(e) => setFormData({...formData, query: e.target.value})}
                  placeholder="Please describe your legal matter or question..."
                  rows="4"
                  className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:border-blue-500 resize-vertical text-sm"
                />
              </div>
              <p className="text-xs text-gray-500 mb-4 text-center">
                Contacting does not create an attorney-client relationship. Do not share confidential information here.
              </p>
              <div className="flex flex-col sm:flex-row gap-4">
                <Button type="submit" className="flex-1 bg-blue-600 hover:bg-blue-700 text-white text-sm">
                  Send Email
                </Button>
                <Button 
                  type="button" 
                  onClick={() => {
                    setShowModal(false);
                    setFormData({ name: '', phone: '', email: '', service: '', query: '', countryCode: '+91' });
                  }}
                  variant="outline" 
                  className="flex-1 text-sm"
                >
                  Cancel
                </Button>
              </div>
            </form>
          </div>
        </div>
      )}
    </div>
  );
}
